<template>
    <div>
        <b-container>
            <h2>Hashtag Suggestions</h2>
            <div class="data-input">
                <b-form-textarea class="caption-text"
                                 v-model="hashtagTextSuggestions"
                                 placeholder="Type a text or caption of your photo"
                                 :rows="3"
                                 :max-rows="12">
                </b-form-textarea>
                <div class="image-upload" v-bind:class="{ cleared: imgCleared }">
                    <img :src="placeholderImg || defaultImage">
                    <div class="overlay">
                        <input type="file" id="file-input" class="file-input" @change="onFileChosen"><label
                            for="file-input">
                        <font-awesome-icon class="uploadIcon" :icon="['fas', 'upload']"/>
                    </label>
                    </div>
                </div>
            </div>
            <div class="buttons-row">
                <b-btn variant="primary" v-if="uploading" disabled>
                    Uploading image
                    <font-awesome-icon :icon="['fas', 'spinner']" spin/>
                </b-btn>
                <b-btn variant="primary" v-else-if="analyzing" disabled>
                    Analyzing
                    <font-awesome-icon :icon="['fas', 'spinner']" spin/>
                </b-btn>
                <b-btn variant="primary" v-else class="pulse-button suggestion-btn" @click="fetchHashtagSuggestions">
                    <span>Suggest Hashtags</span>
                </b-btn>
                <b-btn variant="outline-secondary" class="suggestion-btn ml-2" @click="clear">Clear</b-btn>
            </div>
            <div class="suggestion-row">
                <div v-if="!showSuggestedHashtags" class="try-me-out">
                    <img class="arrow-top" src="https://cdn.ritekit.com/assets/img/common/arrow-signup.png">
                    Try me out!
                </div>
                <div v-else>
                    <HashtagInput :suggestedHashtags="suggestedHashtags" :save=true :load=true :compare=true :copy=true
                                  :instagram="true" :banned="true"/>
                </div>
            </div>
        </b-container>
        <br>
    </div>
</template>

<script>
    import HashtagInput from "./helpers/HashtagInput";
    import {api} from "../_services" // TODO move to VUEX
    import {mapActions, mapState} from "vuex";

    export default {
        name: "HashtagSuggestions",
        components: {
            HashtagInput
        },
        data() {
            return {
                hashtagTextSuggestions:
                    "Though we travel the world over to find the beautiful, we must carry it with us or we find it not.",
                showSuggestedHashtags: false,
                suggestedHashtags: [],
                imgLoading: false,
                imgCleared: false,
                loading: false,
                selectToggle: true,
                currentRoute: this.$route.path,
                analyzing: false,
                uploading: false,
                placeholderImg: '',
                currentImage: null,
                defaultImage: 'https://cdn.ritekit.com/assets/img/ritetag/blonde.jpg'
            };
        },
        computed: {
            ...mapState('account', ['info'])
        },
        methods: {
            ...mapActions('comparison', ["setCompareSuggestedHashtags"]),
            ...mapActions('account', ["startTrial"]),
            clear() {
                this.hashtagTextSuggestions = ''
                this.placeholderImg = null
                this.imgLoading = true
                this.imgCleared = true
                this.showSuggestedHashtags = false
            },
            changeCurrentRoute() {
                if (this.currentRoute !== this.$route.path) {
                    this.$emit('changeRoute') // TODO WTF
                }
            },
            onFileChosen(e) {
                let files = e.target.files || e.dataTransfer.files
                if (!files.length)
                    return;
                this.currentImage = files[0]
                this.createImage(files[0])
                this.imgCleared = false
            },
            createImage(file) {
                let reader = new FileReader()
                reader.onload = (e) => {

                    this.placeholderImg = e.target.result
                    this.imgLoading = true
                    this.imgCleared = false
                };
                reader.readAsDataURL(file)
            },
            async fetchHashtagSuggestions() {
                if (this.info.noPlanStarted) {
                    await this.startTrial()
                }
                if (!this.currentImage && !this.imgCleared) {
                    this.hashtagSuggestion({
                        text: this.hashtagTextSuggestions,
                        image: this.defaultImage
                    })
                    return
                } else if (!this.currentImage && this.imgCleared) {
                    this.hashtagSuggestion({
                        text: this.hashtagTextSuggestions
                    })
                    return
                }
                const formData = new FormData();
                formData.append("file", this.currentImage);
                this.uploading = true
                api.uploadImage(formData).then(r => {
                    this.uploading = false
                    this.hashtagSuggestion({
                        text: this.hashtagTextSuggestions,
                        image: r.data.file.uri
                    })
                }).catch(e => {
                    this.uploading = false
                    // TODO
                })

            },
            async hashtagSuggestion (data) {
                try {
                    this.analyzing = true;
                    const response = await api.hashtagSuggestion(data)
                    const res = response.data
                    this.analyzing = false;
                    this.showSuggestedHashtags = true;
                    this.suggestedHashtags = res.data
                } catch (err) {
                    this.analyzing = false
                    let message = {}
                    if (err && err.response) {
                        switch (err.response.status) {
                            case 402:
                                message = {
                                    type: 'warn',
                                    text: 'Your trial expired. Upgrade to keep using RiteTag'
                                }
                                break;
                            default:
                                message = {
                                    type: 'error',
                                    text: 'Oops! There was an error. Check your internet connection and refresh the page'
                                }
                                break;
                        }
                    }
                    this.$notify(message)
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .data-input {
        display: inline-flex;
        height: 150px;
        width: 100%;

        /deep/ .caption-text {
            height: 100% !important;
            width: 100%;
            border-radius: 0.25rem 0 0 0.25rem;
            overflow-y: auto !important;
        }

        .image-upload {
            position: relative;
            border-radius: 0 0.25rem 0.25rem 0;
            border: 1px solid silver;
            border-left: 0px;

            img {
                height: 148px;
                min-width: 100px;
                max-width: auto !important;
            }

            .overlay {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                height: 100%;
                width: 100%;
                opacity: 0;
                transition: .3s ease;
                background-color: white;
                cursor: pointer;

                .file-input {
                    opacity: 0;
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    height: 100%;
                    width: 100%;
                    cursor: pointer;
                }

                .uploadIcon {
                    height: 30px;
                    font-size: 100px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    text-align: center;
                    cursor: pointer;
                }
            }

            &:hover .overlay, &.cleared .overlay {
                opacity: 0.9
            }

        }
    }

    .buttons-row {
        margin-top: 5px;
        margin-bottom: 20px;
    }

    .suggestion-row {
        margin-left: 0px;
        margin-top: 5px;

        .arrow-top {
            margin-bottom: 8px;
            margin-left: 95px;
            vertical-align: text-bottom;
            height: 30px;
        }

        .try-me-out {
            margin-top: 8px;
            margin-right: 10px;
            color: $gray-500;
        }
    }

    .selectHashtagDisplay {
        margin-left: -17px;
        width: 110%;
    }

    .pulse-button {
        position: relative;
        border: none;
        box-shadow: 0 0 0 0 #ac2a83;
        background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
        -webkit-animation: pulse 2s infinite cubic-bezier(0.3, 0, 0, 1);
        -moz-animation: pulse 2s infinite cubic-bezier(0.3, 0, 0, 1);
        -ms-animation: pulse 2s infinite cubic-bezier(0.3, 0, 0, 1);
        animation: pulse 2s infinite cubic-bezier(0.3, 0, 0, 1);
    }

    .pulse-button:hover {
        -webkit-animation: none;
        -moz-animation: none;
        -ms-animation: none;
        animation: none;
    }

    @-webkit-keyframes pulse {
        to {
            box-shadow: 0 0 0 10px rgba(232, 76, 61, 0);
        }
    }

    @-moz-keyframes pulse {
        to {
            box-shadow: 0 0 0 10px rgba(232, 76, 61, 0);
        }
    }

    @-ms-keyframes pulse {
        to {
            box-shadow: 0 0 0 10px rgba(232, 76, 61, 0);
        }
    }

    @keyframes pulse {
        to {
            box-shadow: 0 0 0 10px rgba(232, 76, 61, 0);
        }
    }
</style>
